export default "__VITE_ASSET__kt6Nt0zJ__"